/**
 * GT-12 tracking event types
 */
export var GT12EventType;
(function (GT12EventType) {
    /**
     * Sent when a user pauses a program.
     *
     * Only triggered for sessions impacted by GT-12 BV, i.e. those that may trigger an ad.
     */
    GT12EventType["PAUSE"] = "PAUSE";
    /**
     * Sent before a VAST manifest is requested from RAP server.
     */
    GT12EventType["AD_REQUEST"] = "AD_REQUEST";
    /**
     * Sent when a VAST manifest is received from RAP server.
     */
    GT12EventType["AD_RESPONSE"] = "AD_RESPONSE";
    /**
     * Sent when a user fast forwards a program (actual fast forwards, not attempts).
     *
     * Only triggered for sessions impacted by GT-12 BV, i.e. those that may trigger an ad.
     */
    GT12EventType["FAST_FORWARD"] = "FAST_FORWARD";
    /**
     * Sent when a Pause Ad starts being displayed.
     */
    GT12EventType["AD_PAUSE_DISPLAY"] = "AD_PAUSE_DISPLAY";
    /**
     * Sent once a Pause Ad has been displayed for 10 sec.
     */
    GT12EventType["AD_PAUSE_10_SEC"] = "AD_PAUSE_10_SEC";
    /**
     * Sent when we start playing an Ad Break.
     */
    GT12EventType["AD_START"] = "AD_START";
    /**
     * Sent when each individual media of an Ad Break finishes.
     */
    GT12EventType["AD_COMPLETE"] = "AD_COMPLETE";
    /**
     * Sent when a user starts a replay stream that triggers the Start ad requests.
     */
    GT12EventType["REPLAY"] = "REPLAY";
})(GT12EventType || (GT12EventType = {}));
